// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".default-sidebar[data-v-53c048ca]{min-width:225px;border-top:2px solid #ebebeb}.default-sidebar .sidebar-item[data-v-53c048ca]{background-color:#fafafa;cursor:pointer}", ""]);
// Exports
module.exports = exports;
